import React, {Component} from 'react';
import {
  BrowserRouter, Route, // Link,
  Switch, Redirect
} from 'react-router-dom';
// import {firebaseAuth} from '../config/constants';

// components / nav
import Nav from './nav/Nav';
// components / core
import Video from './core/video/Video';
import Talent from './core/talent/Talent';
import Viral from './core/viral/Viral';
import Rates from './core/rates/Rates';
// components / footer
import Footer from './footer/Footer';
// components / auth
import Register from './auth/register/Register';
import Login from './auth/login/Login';
import Reject from './auth/reject/Reject';
import Dash from './auth/dash/Dash';
import Verify from './auth/verify/Verify';
import EnterEmail from './auth/verify/EnterEmail';
import Verified from './auth/verify/Verified';
// components / info
import FAQ from './info/faq/Faq';
import PrivacyPolicy from './info/privacy-policy/PrivacyPolicy';
import TermsOfUse from './info/terms-of-use/TermsOfUse';

function PrivateRoute({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === true ? <Component {...props}/> :
        <Redirect to={{pathname: '/reject', state: {from: props.location}}}/>
      }
    />
  );
}

function PublicRoute({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false ? <Component {...props} /> :
        <Redirect to='/dash'/>}
    />
  );
}

export default class App extends Component {
  state = {
    authed: false
  };

  // componentDidMount() {
  //   this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
  //     if (user) {
  //       this.setState({
  //         authed: true
  //       });
  //     } else {
  //       this.setState({
  //         authed: false
  //       });
  //     }
  //   });
  // }
  //
  // componentWillUnmount() {
  //   this.removeListener();
  // }

  render() {
    return (
      <BrowserRouter>
        <div>
          <Nav/>
          <Switch>
            <Route exact path="/" component={Viral}/>
            <Route path="/video" component={Video}/>
            <Route path="/talent" component={Talent}/>
            <Route path="/privacy.policy" component={PrivacyPolicy}/>
            <Route path="/terms.of.use" component={TermsOfUse}/>
            <Route path="/frequently.asked.questions" component={FAQ}/>
            <PublicRoute authed={this.state.authed} path="/rates"
                         component={Rates}/>
            <PublicRoute authed={this.state.authed} path="/register"
                         component={Register}/>
            <PublicRoute authed={this.state.authed} path="/login"
                         component={Login}/>
            <PublicRoute authed={this.state.authed} path="/reject"
                         component={Reject}/>
            <Route path="/verify" component={Verify}/>
            <Route path="/enter-email" component={EnterEmail}/>
            <Route path="/verified" component={Verified}/>
            <PrivateRoute authed={this.state.authed} path="/dash"
                          component={Dash}/>
            <Route render={() => <Redirect to="/"/>}/>
          </Switch>
          <Footer/>
        </div>
      </BrowserRouter>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/App.js